import React from 'react';

import routes from 'js/core_pre_webpack/routes';
import { Icon } from 'js/design_system/Icon';

import { IconAnchor, IconContainer, IconLabel } from './styles';

type Props = {
  onClick?: () => void;
};

const LibraryButton = ({ onClick }: Props) => (
  <IconAnchor
    key="bookmarks"
    data-coachmark-step="toolbar-library"
    href={routes.bookmarks_url({
      from_navbar: true,
      trigger: 'nav',
    })}
    onClick={onClick}
  >
    <IconContainer>
      <Icon name="bookmark" size={25} />
    </IconContainer>
    <IconLabel>Your library</IconLabel>
  </IconAnchor>
);

export default LibraryButton;
